import React from 'react'
import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import Image from '@/components/Image'

export interface CallToActionLink {
  link: any
}

export interface CallToActionProps {
  links?: CallToActionLink[]
  richText?: any
  media?: any
  className?: string
}

export const CallToAction: React.FC<CallToActionProps> = ({ 
  links, 
  richText, 
  media,
  className 
}) => {
  return (
    <div className={`relative ${className || ''}`}>
      {/* A lazy, optimized image rather than a CSS `background-image`, which always downloaded
          the full-size original as soon as the block rendered, wherever it was on the page. */}
      {typeof media === 'object' && media?.url && (
        <Image src={media.url} alt="" fill sizes="100vw" className="object-cover" />
      )}
      <div className="relative flex flex-col items-center justify-center text-white text-center h-[100dvh]">
        <div className="flex items-center">
          {richText && (
            <RichText className="mb-0" content={richText} enableProse={true} enableGutter={false} />
          )}
        </div>
        <div className="flex flex-col gap-8 mt-4">
          {(links || []).map(({ link }, i) => {
            return <CMSLink key={i} size="lg" {...link} />
          })}
        </div>
      </div>
    </div>
  )
}